export default {
	user: null,
	token: null,
	permissions: null
}